//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'OpleidingOverzicht',
  data: () => ({
    leertherapie: null,
    contracturen: null,
    supervisie: null,
    dsm: null,
  }),
  computed: {
    diplomaTypes() {
      return [
        'application/pdf',
        'image/jpeg',
        'image/png',
      ].join(',');
    },
    diplomaValidation() {
      return `bail|required|mime:${this.diplomaTypes}`;
    },
  },
};
